// BillingScreen.js
import React from "react";
import CheckBox from "../../../../Components/CheckBox";
import editIcon from "../../../../Assets/Icons/edit.png";
import deleteIcon from "../../../../Assets/Icons/delete.png";
import forwordIcon from "../../../../Assets/Icons/forward.png";
import useBillingController from "../../../Controllers/AdminScreens/Clients/BillingController";
import Loader from "../../../../Components/Loader";
import downArrow from '../../../../Assets/Icons/chevron-down.png';
import DeleteConfirmationModal from "../../../../Components/Modals/DeleteConformationModal";

const BillingScreen = ({ clientInfo, billFeeList, billFeeListError, billFeeListLoading, onRefresh }) => {
  const {
    currentTasks,
    services,
    selectAll,
    checkedStates,
    totalBalance,
    handleSelectAll, handleAddInvoice,
    handleCheckboxChange, handleSendReminder,
    getStatusStyle, currentPage,
    totalPages, handleInvoiceDwd, handleReceiptDwd,
    handlePageChange, visiblePages,
    sendReminderError, sendReminderLoader, sendReminderSucces,
    handleInvoiceEdit, handleDeleteInvoiceFile,
    confirmDeleteInvoice, handleCloseDeleteModal, isDeleteModalOpen,
    successMesg, printInvoiceError, deleteLoading, invoiceInfoRef
  } = useBillingController(billFeeList, clientInfo, onRefresh);
  console.log('currentTasks:-', currentTasks)

  return (
    <div className="tasksScreen-task-table-wrapper">
      <h3 className="basic-info-header">Agreed Billing & Fees</h3>
      <table className="tasksScreen-task-table">
        <thead>
          <tr>
            <th style={{ width: "5%" }}>
              <CheckBox checked={selectAll} onChange={handleSelectAll} />
            </th>
            <th style={{ width: "15%" }}>Service Name</th>
            <th style={{ width: "10%" }}>Agreed Fees</th>
            <th style={{ width: "10%" }}>Frequency</th>
            <th style={{ width: "10%" }}>Remark</th>
            <th style={{ width: "10%" }}>Status</th>
            <th style={{ width: "10%" }}>Paid Amt</th>
            <th style={{ width: "10%" }}>Invoice</th>
            <th style={{ width: "10%" }}>Receipt</th>
            <th style={{ width: "10%",textAlign:'center' }} onClick={handleAddInvoice}>+ New Service</th>
          </tr>
        </thead>
        <tbody style={{ backgroundColor: "white" }}>
          {currentTasks?.map((service, index) => (
            <tr
              key={index}
              style={{
                borderBottom: "3px solid #f8f9fa",
              }}
            >
              <td>
                <CheckBox
                  checked={service?.checked || false}
                  onChange={(isChecked) => handleCheckboxChange(isChecked, service?.invoice_id)}
                // disabled={service?.invoice_gen_status === 1}
                />
              </td>
              <td style={styles.tableValue}>{service?.service_category_names || '--'}</td>
              <td style={styles.tableValue}>{service?.invoice_amt_total}</td>
              <td style={styles.tableValue}>{service?.financial_period || '--'}</td>
              <td style={styles.tableValue}>{service?.task_description || '--'}
                {printInvoiceError[service?.invoice_id] &&
                  <div style={{ color: 'red', paddingTop: 10 }} >{printInvoiceError[service?.invoice_id]}</div>}
                {successMesg[service?.invoice_id] &&
                  <div style={{ color: 'green', paddingTop: 10 }} >{successMesg[service?.invoice_id]}</div>}

              </td>
              <td style={styles.tableValue}>
                <div
                  style={{
                    display: "inline-block",
                    padding: "5px 10px",
                    borderRadius: "15px",
                    ...getStatusStyle(service?.invoice_status_text),
                  }}
                >
                  {service?.invoice_status_text || '--'}
                </div>
              </td>
              <td style={styles.tableValue}>{service?.invoice_amt_paid}</td>
              <td style={styles.tableLink} onClick={() => handleInvoiceDwd(service?.invoice_id)}>
                {service?.invoice_id_gen || '--'}
              </td>
              <td>
                {service?.receipts?.length > 0 ? (
                  <span>
                    {service.receipts.map((receipt, index) => (
                      <span
                        key={index}
                        style={styles.tableLink}
                        onClick={() => handleReceiptDwd(service?.invoice_id, receipt?.receipt_id)}
                      >
                        {receipt?.receipt_no}
                        {index !== service.receipts.length - 1 && ", "} {/* Add comma between IDs */}
                      </span>
                    ))}
                  </span>
                ) : (
                  <span>--</span>
                )}
              </td>

              <td>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 5, borderBottom: 'none' }}>
                {deleteLoading[service?.invoice_id] &&
                  <span style={{ marginLeft: '5px' }}>
                    <Loader loading={deleteLoading[service?.invoice_id]} color={'var(--primary-loader-color)'} size="small" />
                  </span>
                }
                <button
                  className="tasksScreen-edit-button"
                  style={{
                    border: "none",
                    background: "transparent", cursor: deleteLoading[service?.invoice_id] ? "not-allowed" : "pointer",
                    opacity: deleteLoading[service?.invoice_id] ? 0.5 : 1,
                  }}
                  onClick={() => handleInvoiceEdit(service)}
                  disabled={deleteLoading[service?.invoice_id]}
                >
                  <img
                    src={editIcon}
                    alt="Edit"
                    style={{ width: "16px", height: "16px" }}
                  />
                </button>
                <button className="tasksScreen-delete-button"
                  style={{
                    border: "none",
                    background: "transparent",
                    cursor: deleteLoading[service?.invoice_id] ? "not-allowed" : "pointer",
                    opacity: deleteLoading[service?.invoice_id] ? 0.5 : 1,
                  }}
                  disabled={deleteLoading[service?.invoice_id]}
                  onClick={() => confirmDeleteInvoice(service)}>
                  <img
                    src={deleteIcon}
                    alt="Delete"
                    style={{ width: "16px", height: "16px" }}
                  />
                </button>
                </div>
              </td>
            </tr>
          ))}
          {/* Total Balance Row */}
          <tr
            style={{
              backgroundColor: "#EDF1D6",
              borderBottom: "2px solid black",
            }}
          >
            <td colSpan="2" style={styles.tableValue}>
              Total Balance
            </td>
            <td colSpan="1" style={styles.tableValue}>
              {totalBalance.toFixed(2)}
            </td>
            <td colSpan="7" style={{ padding: "10px 12px" }}>
              <div className="tasksScreen-table-footer" style={{ display: 'flex', alignItems: 'center', marginTop: 0 }}>
                <span className="tasksScreen-pagination-info"
                  style={{
                    whiteSpace: "nowrap",
                    // overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}>
                  {`${currentPage}-${totalPages} of items`}
                </span>
                <div className="tasksScreen-pagination" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', maxWidth: '100%' }}>
                  <button
                    className="tasksScreen-pagination-button"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1 || totalPages === 0}
                  >
                    <img
                      src={downArrow}
                      alt="Previous"
                      className="tasksScreen-arrow-left tasksScreen-icon-image"
                    />
                  </button>
                  {visiblePages.map((page) => (
                    <button
                      key={page}
                      className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`}
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </button>
                  ))}
                  <button
                    className="tasksScreen-pagination-button"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages || totalPages === 0}
                  >
                    <img
                      src={downArrow}
                      alt="Next"
                      className="tasksScreen-arrow-right tasksScreen-icon-image"
                    />
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      {billFeeListLoading && <Loader loading={billFeeListLoading} color={'var(--primary-loader-color)'} />}
      {billFeeListError && <div className="list-error-msg"> {billFeeListError} </div>}
      {sendReminderError && <div className="list-error-msg"> {sendReminderError} </div>}
      {sendReminderSucces && <div className="list-success-msg"> {sendReminderSucces} </div>}
      <button
        style={{
          marginTop: "10px",
          padding: "10px 20px",
          backgroundColor: "var(--button-bg-color)",
          color: "var(--button-text-color)",
          border: "none",
          borderRadius: "20px",
          cursor: "pointer",
          opacity: sendReminderLoader ? 0.5 : 1,
          display:'flex',
          alignItems:'center',gap:5
        }}
        onClick={handleSendReminder}
        disabled={sendReminderLoader}
      >
        {sendReminderLoader && <span style={{ paddingRight: 10 }}><Loader loading={sendReminderLoader} color='#FFFFFF' size='small' /></span>}
        Send Reminder
      </button>
      <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        message={`Are you sure you want to delete ${invoiceInfoRef.current?.invoice_id_gen}?`}
        onClose={handleCloseDeleteModal}
        onConfirm={() => {
          handleCloseDeleteModal(); // Close modal
          handleDeleteInvoiceFile(invoiceInfoRef.current); // Perform delete operation
        }}
      />
    </div>
  );
};

const styles = {
  tableValue: {
    color: "#192A3E",
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: "12px",
  },
  tableLink: {
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: "12px",
    textDecoration: "underline",
    color: "#5A55D2",
    cursor: 'pointer'
  },
};

export default BillingScreen;
